import React from 'react';
import PropTypes from 'prop-types';
import {Card} from "antd";
import {useDispatch} from "react-redux";
import appActions from "@web/redux/app/actions";
import {LineChartIcon} from "@web/assets/icons";
import DataTable from "./DataTable";

DatasetCard.propTypes = {
  dataset: PropTypes.object,
  sampleRecords: PropTypes.array,
  path: PropTypes.string,
  preview: PropTypes.bool,
};

function DatasetCard(props) {
  const dispatch = useDispatch();
  const setActiveDetail = () => {
    dispatch(appActions.setActiveDetail({path: props.path, data: props.dataset}, true));
  };

  // const getTitle = () => {
  //   return <div className="space space-between">
  //     <span className="bolded capitalize">
  //       {props.dataset?.name}
  //     </span>
  //     <Tooltip
  //       title={<Card
  //         title="Launch AI Analyst"
  //         className="card-simple card-rounded"
  //         style={{width: 300}}
  //       >
  //         <Card.Meta
  //           description="Analyst is your powerful AI to explore data and find insights using natural language"/>
  //       </Card>}
  //       trigger={["hover"]}
  //     >
  //       <Button
  //         shape="round"
  //         onClick={setActiveDetail}
  //         className="green-color icon-btn"
  //         size={"middle"}
  //       >
  //         <TerminalIcon className="menu-icon" size={18} /> Launch Analyst
  //       </Button>
  //     </Tooltip>
  //   </div>;
  // }

  return props.preview ?
    <DataTable
      width={800}
      path={props.path}
      dataset={props.dataset}
      sampleRecords={props.sampleRecords}
    /> :
    <Card
      style={{width: 300, height: "100%"}}
      title={
      <div className="space space-center-y">
        <LineChartIcon className="muted-icons" />
        {props.dataset?.name}
      </div>
      }
      hoverable
      onClick={setActiveDetail}
      className="card-rounded card-simple card-transparent card-inline"
      bordered={false}
    >
      <span className="muted">{props.dataset?.description}</span>
    </Card>;
}

export default DatasetCard;
